(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/eurojackpot/components/start/assets/react/start-page.js') >= 0) return;  svs.modules.push('/modules/eurojackpot/components/start/assets/react/start-page.js');

'use strict';

const FullscreenWidgetProvider = svs.eurojackpot.react.context.FullscreenWidgetProvider;
const _svs$eurojackpot$reac = svs.eurojackpot.react.components,
  HeaderText = _svs$eurojackpot$reac.HeaderText,
  PlayButtons = _svs$eurojackpot$reac.PlayButtons,
  HowToLink = _svs$eurojackpot$reac.HowToLink,
  NavigationButtons = _svs$eurojackpot$reac.NavigationButtons,
  PlayOwnButton = _svs$eurojackpot$reac.PlayOwnButton,
  FullscreenWidget = _svs$eurojackpot$reac.FullscreenWidget;
const StartPage = () => React.createElement(FullscreenWidgetProvider, null, React.createElement("div", {
  className: "eurojackpot-start-page-container"
}, React.createElement("div", {
  className: "eurojackpot-start-page-main-content"
}, React.createElement("div", null, React.createElement(HeaderText, null), React.createElement(PlayOwnButton, null), React.createElement(PlayButtons, null)), React.createElement(HowToLink, null)), React.createElement(NavigationButtons, null), React.createElement(FullscreenWidget, null)));
const rootEl = document.getElementById('ngStartPageRegion');
if (rootEl) {
  ReactDOM.render(React.createElement(StartPage, null), rootEl);
}

 })(window);